import React from 'react';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { getGlobalDealerName } from './globalState';
import { getBrand } from './brands';
import BackButton from './BackButton';

function QuickStartGuide() {
  /*
  This component provides a quick start guide for users to follow when using the photography app.
  It includes steps for clearing the lot, capturing photos, and sending them for retouching.
  */
  const navigate = useNavigate();
  const dealerName = getGlobalDealerName();
  // No guidePDF in the brand config = no guide button (see brands.js).
  const guideURL = getBrand(dealerName)?.guidePDF;

  const handleButtonClick = () => {
    navigate('/photography');
  };

  return (
    <div className="QuickStartGuide">
      <h1>It's as easy as 1, 2, 3</h1>
      <ol className="QuickStartGuide-list">
        <li className="QuickStartGuide-item">
          <div className="QuickStartGuide-images">
            <img src="/components/icons/Clean_Icon.png" className="QuickStartGuide-image" alt="Clean" />
          </div>
          <div className="QuickStartGuide-text">
            Clear the lot in front of your store according to the site survey you received from us.
            <br />
            <a href="#" className="QuickStartGuide-link">Resend site survey</a>
          </div>
        </li>
        <li className="QuickStartGuide-item">
          <div className="QuickStartGuide-images">
            <img src="/components/icons/SmartPhone_Camera.png" className="QuickStartGuide-image" alt="Smartphone Camera" />
          </div>
          <div className="QuickStartGuide-text">
            Capture your dealership using the photography portion of this app.
          </div>
        </li>
        <li className="QuickStartGuide-item">
          <div className="QuickStartGuide-images">
            <img src="/components/icons/Send_Photos.png" className="QuickStartGuide-image-send" alt="Send Photos" />
          </div>
          <div className="QuickStartGuide-text">
            Send us the pictures directly from the app, using transfer. We'll retouch them and send them back to you for approval.
          </div>
        </li>
      </ol>
      {guideURL && (
        <button
          className="PhotoGuide-button"
          onClick={() => window.open(guideURL, '_blank')}
        >
          View {dealerName} Photo Guide
        </button>
      )}
      <button className="Next-button" onClick={handleButtonClick}>Next</button>
      <BackButton />
    </div>
  );
}

export default QuickStartGuide;
